import React from 'react';
import dynamic from 'next/dynamic';

const Index = (props) => <React.Fragment>{props.children}</React.Fragment>;

export const NoSSR = dynamic(() => Promise.resolve(Index), {
  ssr: false,
});

export default NoSSR;
